<template>
  <BlockWrapper class="why-bimlib" small>
    <bim-text type=h5 bold class="text-center why-bimlib__title">Почему мы?</bim-text>
    <bim-row class="achievment__wrapper">
      <bim-col
        cols=12
        md=6
        v-for="achiev of achievs"
        :key="achiev.title"
        class="d-flex align-start achievment"
      >
        <img :src="achiev.img" alt :width="achiev.imgWidth" :style="{ margin: achiev.imgPadding }" />
        <div class="d-flex flex-column">
          <bim-text type=main class="achievment__title mb-6" bold>{{ achiev.title }}</bim-text>
          <bim-text type=medium class="achievment__desc" v-html="achiev.desc"></bim-text>
        </div>
      </bim-col>
    </bim-row>
  </BlockWrapper>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'
import bimContainer from '@bimlib/components/bimContainer'

export default {
  name: "block",
  components: {
    bimCol,
    bimRow,
    bimContainer,
  },
  inject: ['getImgPath'],
  computed: {
    achievs() {
      return [
        {
          title: "Менеджеры-профи",
          img: this.getImgPath('img-special-landing-cash-8.svg'),
          imgWidth: "23px",
          imgPadding: "0 34px 0 14px",
          desc: "Наши сотрудники закрывают самые непростые сделки, средний стаж в отделе 3 года. Настоящие профи.",
        },
        {
          title: "Качество исполнения",
          img: this.getImgPath('img-special-landing-cash-9.svg'),
          imgWidth: "40px",
          imgPadding: "0 24px 0 0",
          desc: "Для клиентов - только самое лучшее. У нас нет недовольных, зато есть <a href='/cases/' class='achievment__link' target='_blank'>успешные кейсы</a>",
        },
        {
          title: "Выплаты в срок",
          img: this.getImgPath('img-special-landing-cash-10.svg'),
          imgWidth: "39px",
          imgPadding: "0 29px 0 0",
          desc: "Все условия прописаны в договоре, а за выплатами следят роботы - их не обмануть и они не забывают.",
        },
        {
          title: "Ощутимые награды деньгами",
          img: this.getImgPath('img-special-landing-cash-11.svg'),
          imgWidth: "38px",
          imgPadding: "0 23px 0 0",
          desc: "О том как я смогу вывести деньги. Адреса почты и телефона с именем будет достаточно, чтобы мы могли сами связаться с клиентом.",
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.why-bimlib {
  padding: 80px 0;
  background-color: #f7f7f7;

  .why-bimlib__title {
    margin-bottom: 80px;
  }
}
.achievment {
  &:nth-child(1) {
    padding-bottom: 64px;
  }
  .achievment__title {
    font-size: 20px;
    line-height: 1.3;
  }
  .achievment__desc {
    line-height: 1.57;
    letter-spacing: 0.2px;
  }
  ::v-deep .achievment__link {
    border-bottom: 1px solid $primary-color;
    padding-bottom: 4px;

    &:hover {
      opacity: .8;
    }
  }
} 
</style>
